import React from "react";
import { FaSearch } from "react-icons/fa";
import { motion } from "framer-motion";

export default function FaSearchAni({ size = 18, color = "#181C20" }) {
  return (
    <motion.span
      whileHover={{
        scale: 1.18,
        rotate: 180,
        boxShadow: "0px 3px 20px 0px #00000022",
      }}
      whileTap={{
        scale: 0.92,
        rotate: 180,
        boxShadow: "0px 1px 4px 0px #00000011",
      }}
      transition={{
        type: "spring",
        stiffness: 480,
        damping: 22,
      }}
      style={{
        display: "inline-block",
        // Kein borderRadius, kein padding, kein BG
      }}
    >
      <FaSearch size={size} color={color} />
    </motion.span>
  );
}
